import { render } from "./ForgotPassword.vue?vue&type=template&id=8ea31eb2&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=8ea31eb2&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ea31eb2"]])

export default __exports__